import React from "react";

import {
  buildNote,
  getAckInfo,
  getDisplayTime,
  normalizeTypeLabel,
  typeBadgeClass,
} from "../../utils/eventUtils";

export default function EventMobileList({ logs, onWatchClip }) {
  return (
    <div className="space-y-3 md:hidden">
      {logs.length === 0 ? (
        <div className="rounded-[22px] border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 dark:border-white/10 dark:bg-[#0F172A] dark:text-gray-400">
          표시할 이벤트가 없습니다.
        </div>
      ) : (
        logs.map((row, idx) => (
          <div
            key={`${row?.eventType || "EV"}_${row?.deviceId || "NOID"}_${
              row?._timeMs || idx
            }_${idx}`}
            className="rounded-[22px] border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-[#0F172A]"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  시간
                </div>
                <div className="mt-1 break-keep text-sm font-semibold text-gray-800 dark:text-gray-100">
                  {getDisplayTime(row)}
                </div>
              </div>

              <span
                className={`inline-flex shrink-0 whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold ${typeBadgeClass(
                  row
                )}`}
              >
                {normalizeTypeLabel(row)}
              </span>
            </div>

            <div className="mt-4 grid grid-cols-1 gap-3">
              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  장비명
                </div>
                <div className="mt-1 break-words text-sm font-medium text-gray-900 dark:text-white">
                  {row?.deviceName || row?.deviceId || "-"}
                </div>
              </div>

              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  내용
                </div>
                <div className="mt-1 break-words text-sm text-gray-700 dark:text-gray-200">
                  {row?.message || "-"}
                </div>
              </div>

              <div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  비고
                </div>
                <div className="mt-1 break-words text-sm text-gray-600 dark:text-gray-300">
                  {buildNote(row)}
                </div>
              </div>

              {(() => {
                const ack = getAckInfo(row);
                if (!ack) return null;
                return (
                  <div>
                    <div className="text-xs text-gray-500 dark:text-gray-400">
                      처리(확인)
                    </div>
                    {ack.fp ? (
                      <div className="mt-1 space-y-1">
                        <div className="flex items-center gap-1.5">
                          <span className="inline-flex shrink-0 rounded-full bg-rose-100 px-2 py-0.5 text-[11px] font-semibold text-rose-700 dark:bg-rose-500/15 dark:text-rose-300">
                            오탐
                          </span>
                          <span className="text-xs font-semibold text-gray-800 dark:text-gray-100">
                            {ack.fpBy || ack.by || "-"}
                          </span>
                        </div>
                        {(ack.fpAt || ack.at) && (
                          <div className="text-[11px] text-gray-400">
                            {ack.fpAt || ack.at}
                          </div>
                        )}
                      </div>
                    ) : !ack.done ? (
                      <div className="mt-1">
                        <span className="inline-flex rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-700 dark:bg-amber-500/15 dark:text-amber-300">
                          미확인
                        </span>
                      </div>
                    ) : (
                      <div className="mt-1 space-y-1">
                        <div className="flex items-center gap-1.5">
                          <span className="inline-flex shrink-0 rounded-full bg-emerald-100 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300">
                            확인완료
                          </span>
                          <span className="text-xs font-semibold text-gray-800 dark:text-gray-100">
                            {ack.by || "-"}
                          </span>
                        </div>
                        {ack.note && (
                          <div className="break-words text-xs text-gray-600 dark:text-gray-300">
                            “{ack.note}”
                          </div>
                        )}
                        {ack.at && (
                          <div className="text-[11px] text-gray-400">
                            {ack.at}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })()}

              {String(row?.eventType || "").toUpperCase() ===
                "PPE_VIOLATION" && (
                <button
                  type="button"
                  onClick={() => onWatchClip?.(row)}
                  className="mt-1 w-full rounded-lg bg-blue-600 px-3 py-2 text-sm font-semibold text-white hover:bg-blue-700"
                >
                  캡처 보기
                </button>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
}